module.exports = __webpack_public_path__ + "static/img/qdht.4e53a45.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/header1/img/qdht.png
// module id = 307
// module chunks = 40 41 42